let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cHmsx")).then(() => parcelRequire('42hIE'));